import React, { Component } from 'react'

const PrivacyTerms = () => {
  return (
    <div>

      주식회사 아이콘(이하 '회사'라 함)가 운영하는 인터넷 사이트(http://www.hausplanner.com, 이하 '하우스플래너'라 함)는 개인정보보호법에 따라 이용자의 개인정보 보호 및 권익을 보호하고 개인정보와 관련한 이용자의 고충을 원활하게 처리할 수 있도록 다음과 같은 처리방침을 두고 있습니다.<br/><br/>

      이 개인정보처리방침은 시행일로부터 적용되며, 법령 및 방침에 따른 변경내용의 추가, 삭제 및 정정이 있는 경우에는 변경사항의 시행 7일 전부터 웹사이트 공지사항(또는 개별공지)을 통하여 공지할 것입니다.<br/><br/>

      1. 개인정보 수집 항목 및 이용 목적, 수집 방법<br/>
      - 개인회원 수집항목 : 이름, 이메일, 휴대전화번호<br/>
      - 법인회원 수집항목 : 이름, 이메일, 휴대전화번호, 회사명, 대표자이름, 사업자등록번호 <br/>
      - 이용목적 : 서비스 이용을 위한 회원가입, 마케팅 및 광고에의 활용<br/>
      - 수집방법 : 홈페이지<br/><br/>

      2. 개인정보의 보유 및 이용 기간<br/>
      이용자에게 받은 개인정보는 동의받은 기간 동안 보유합니다. 개인정보의 수집 및 이용목적 달성, 보유기간 만료, 회원의 수집 및 이용 동의 철회시 수집된 개인정보는 열람하거나, 이용할 수 없도록 파기 처리합니다. <br/>
      또한, 회사는 ‘개인정보 유효기간제’에 따라 1년간 서비스를 이용하지 않은 회원의 개인정보를 별도로 분리 보관 또는 삭제하고 있으며, 분리 보관된 개인정보는 4년간 보관 후 지체없이 파기합니다.<br/><br/>

      - 보존항목 : 이름, 이메일, 휴대전화번호, 회사명, 대표자이름, 사업자등록번호 <br/>
      - 보존근거 : 회원 식별 및 부정이용 방지, 회원관리, 서비스 제공, 유료서비스 이용 시 콘텐츠 등의 전송 혹은 요금 정산, 마케팅 및 광고 등에 활용, 서비스 이용 기록에 대한 통계에 활용<br/>
      - 보존기간 : 계약 또는 청약철회 등에 관한 기록 5년, 대금결제 및 재화 등의 공급에 관한 기록 5년, 회원의 불만 또는 분쟁처리에 관한 기록 3년<br/><br/>

      4. 개인정보 제공<br/>
      회사는 이용자의 별도 동의가 있는 경우나, 법령에 규정된 경우를 제외하고는 이용자의 개인정보를 제3자에게 제공하지 않습니다.<br/><br/>

      5. 수집한 개인정보의 위탁<br/>
      회사는 서비스 제공에 반드시 필요한 업무 중 일부를 위해 아래와 같이 외부 전문 업체에 위탁하고 있습니다.<br/>
      - 위탁대상자 : (주)엠엔와이즈<br/>
      - 위탁업무내용 : 회원에게 알림을 목적으로 알림톡, 문자 발송<br/><br/>

      6. 이용자 및 법정 대리인의 권리와 그 행사 방법<br/>
      이용자는 등록되어 있는 자신의 개인정보를 열람하거나 수정할 수 있습니다.<br/>
      개인정보 파기를 위해 개인정보관리책임자에게 서면, 전화 또는 이메일로 연락하시면 지체 없이<br/>
      조치하겠습니다.<br/>
      귀하가 개인정보의 오류에 대한 정정을 요청하신 경우에는 정정을 완료하기 전까지 당해 개인정보를<br/>
      이용 또는 제공하지 않습니다.<br/>
      또한 잘못된 개인정보를 제3자에게 이미 제공한 경우에는 정정 처리결과를 제3자에게 지체없이<br/>
      통지하여 정정이 이루어지도록 하겠습니다.<br/>
      회사는 이용자의 요청에 의해 해지 또는 삭제된 개인정보는 “회사가 수집하는 개인정보의 보유 및<br/>
      이용기간”에 명시된 바에 따라 처리하고 그 외의 용도로 열람 또는 이용할 수 없도록 처리하고<br/>
      있습니다.<br/><br/>

      7. 자동수집장치 설치, 운영, 거부<br/>
      이용자는 자동수집장치인 쿠키 설치에 대한 선택권을 가지고 있으며, 쿠키에 대한 웹브라우저에서 옵션을 통해 제어할 수 있습니다.<br/>
      사용 목적 : 이용자의 서비스 이용행태 파악을 통해 개인 맞춤 서비스 제공<br/><br/>

      8. 개인 정보 관리 책임자<br/>
      개인정보를 보호하는데 있어 귀하께 고지한 사항들에 반하는 사고가 발생할 시에 개인정보보호책임자가 모든 책임을 집니다.<br/>
      기술적인 보완 조치를 했음에도 불구하고, 해킹 등 기본적인 네트워크 상의 위험성에 의해 발생하는 예기치 못한 사고로 인한 정보의 훼손 및 방문자가 작성한 게시물에 의한 각종 분쟁에 관해서 회사는 책임이 없습니다.<br/>
      사용자의 개인정보를 취급하는 책임자는 다음과 같으며, 개인정보 관련 문의 사항에 신속하고 성실하게 답변해드리고 있습니다.<br/><br/>

      [개인 정보관리 책임자]<br/>
      담당자 : 김종민<br/>
      전화번호 :1666-1968<br/>
      전자우편 : ceo@ai-con.co.kr<br/><br/>

      9. 개인정보관련 의견수렴 및 불만처리에 관한 사항<br/>
      회사는 개인정보보호와 관련하여 이용자 여러분들의 의견을 수렴하고 있으며 불만을 처리하기 위하여 모든 절차와 방법을 마련하고 있습니다. 이용자들은 상단에 명시한 개인정보보호 책임자를 참고하여 전화나 메일을 통하여 불만 사항을 신고할 수 있고, 회사는 이용자들의 신고 사항에 대하여 신속하고도 충분한 답변을 해 드릴 것입니다.<br/>
      기타 개인정보 침해에 대한 신고나 상담이 필요하신 경우에는 아래 기관에 문의하실 수 있습니다.<br/>
      개인정보 침해신고센터 (http://www.cyberprivacy.or.kr, 전화 1336)<br/>
      개인정보 분쟁조정위원회 (http://www.kopico.or.kr, 전화 1336)<br/>
      정보보호마크 인증위원회 (http://www.privacymark.or.kr, 전화 02-580- 0533)<br/>
      경찰청 사이버테러대응센터 (http://www.ctrc.go.kr, 전화 02-392- 0330)<br/><br/>

      ○ 본 방침은 2018년 4월 20일부터 시행됩니다.<br/>

    </div>
  )
}

export default PrivacyTerms



// WEBPACK FOOTER //
// ./Src/Components/Policy/PrivacyTerms.js